import { DataItemType, FormControlType } from "@cloudpivot/form/schema";
import schema from "./schema";
import conduct from "./conduct";
import design from "./components/design.vue";
import pc from "@cloudpivot/form/src/common/components/form-staff-selector/pc/index.vue";
import mobile from "@cloudpivot/form/src/common/components/form-staff-selector/mobile/index.vue";
export const info = {
    title: "部门多选",
    type: "departmentMultiSelector",
    icon: "h-icon-all-department-multiple-",
    dataItemType: DataItemType.DeptMulti,
    formControllerType: FormControlType.DepartmentMultiSelector,
    group: "基础控件",
};
export default {
    info,
    schema,
    conduct,
    components: {
        design,
        pc,
        mobile
    },
};
